module.exports = __webpack_public_path__ + "static/MontserratAlternates-Bold-ccc0ac2bdc9244669a4e23588ae655b6.woff2";